import { type ClassValue, clsx } from 'clsx';
import { twMerge } from 'tailwind-merge';

/**
 * Helper standard shadcn/ui pour merger des classes Tailwind sans conflit.
 * Permet ex: cn('px-4', condition && 'px-8') -> 'px-8' (le second gagne).
 */
export function cn(...inputs: ClassValue[]): string {
  return twMerge(clsx(inputs));
}
